module.exports = __webpack_public_path__ + "img/3.a8e2517f.webp";